import { useEntities } from 'app/agriculture/queries/entities/useEntities';
import { BillboardEntityTypes } from 'app/agriculture/models/Entities';
import { InfraType } from 'app/agriculture/mutations/types/entityConfig';
import { Billboard } from 'app/agriculture/FarmMain/MapRenderer/renderers/Billboard';

export function BillboardRenderer({
    entityType,
}: {
    entityType: (typeof BillboardEntityTypes)[number] & InfraType;
}) {
    const entities = useEntities(entityType);

    return (
        <>
            {Array.from(entities).map(([id, { geometry }]) => {
                return (
                    <Billboard
                        key={id}
                        id={id}
                        type={entityType}
                        coordinates={geometry.coordinates}
                    />
                );
            })}
        </>
    );
}
